module.exports = "pegasus_template/assets/themelp1/small/25.png";